import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeFinancialConsultantCard.cardTitle',
    defaultMessage: 'Consulente finanziario',
  },
});
